import {useState} from "react";
import {Box} from "@mui/system";
import {reduxForm} from "redux-form";
import {useDispatch} from "react-redux";
import _ from "lodash";
import {customFieldActions} from "_actions";
import AddCustomFieldFilterSelect from "./AddCustomFieldFilterSelect";
import ActionButton from "../../../../../common/ActionButton";
import {SnackBar} from "../../../../../../common";
import {
    buildAddCustomFieldPayload,
} from "../../../../Vote/Sections/BodySection/Response/CustomField/CustomFieldUtils";

function AddCustomFieldForm({customFields, msgDataSourceId, handleSubmit, handleClose, fetchCustomFieldsLoading}) {
    const [customField, setCustomField] = useState({});
    const dispatch = useDispatch();

    const handleCreateCustomFields = () => {
        if(_.isEmpty(customField)) {
            SnackBar.showMessage("Please select a custom field");
            return;
        }
        const payload = buildAddCustomFieldPayload({customField, msgDataSourceId});
        dispatch(customFieldActions.createCustomField(msgDataSourceId, payload));
        handleClose();
    };

    const handleCustomFieldSelection = (value) => {
        setCustomField(value);
    };

    return (
        <>
            <form name="form" onSubmit={handleSubmit(handleCreateCustomFields)} autoComplete="off">
                <Box sx={{mb: '20px'}}>
                    <AddCustomFieldFilterSelect
                        customFields={customFields}
                        onChange={handleCustomFieldSelection}
                        loadingOptions={fetchCustomFieldsLoading}
                    />
                </Box>

                <Box sx={styles.buttonContainer}>
                    <Box sx={styles.cancelButtonContainer}>
                        <ActionButton
                            label={'Cancel'}
                            action={handleClose}
                            buttonBordered
                            useBorderColor={'#003300'}
                            withIcon={false}
                            sx={styles.cancelButton}
                            type={'button'}
                        />
                    </Box>
                    <Box>
                        <ActionButton
                            label={'Save'}
                            withIcon={false}
                            sx={styles.sendButton}
                        />
                    </Box>
                </Box>
            </form>
        </>
    );
}

const styles = {
    inputDesc: {
        fontFamily: 'LarsseitMedium',
        fontSize: '14px',
        fontWeight: 500,
        color: '#495D5E',
        mb: '5px',
    },
    actionsContainer: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingTop: '15px',
    },
    cancelButtonContainer: {
        width: '84px',
        marginRight: '15px',
    },
    cancelButton: {
        height: '35px',
    },
    sendButton: {
        height: '35px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
};

AddCustomFieldForm = reduxForm({form: 'AddCustomFieldForm'})(AddCustomFieldForm);
export default AddCustomFieldForm;
